exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-fd89d44a] .cursor-not-allowed {\n  cursor: not-allowed;\n}\n", ""]);

// exports
